<template>
  <div class="table-responsive">
    <table :id="tableid" class="table">
      <thead>
        <tr>
          <th v-for="column in todisplay" :class="column == 'description' || column == 'code' ? 'text-left' : 'text-center'" scope="col">
            {{ $t('reports.displays.' + column) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="el in sortedReport">
          <td v-for="column in todisplay" :class="column == 'description' || column == 'code' ? 'text-left' : 'text-center'">
            <span v-if="column != 'fails'">
              {{ (column == 'details' || column == 'prioritary') ? (el[column] ? 'X' : '') : el[column] }}
            </span>
            <span v-else :title="makeToolTip(el)">
              {{ el[column ] }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ReportDisplay',

  props: {
    report: {
      type: Array,
      required: true
    },
    todisplay: {
      type: Array,
      required: true
    },
    sort: {
      type: Number,
      required: true
    },
    type: {
      type: Number,
      required: true
    },
    filter: {
      type: Number,
      required: true
    },
    tableid: {
      type: String,
      required: true
    }
  },

  data: () => ({
    sorts: [{ id: 1, text: 'code' }, { id: 2, text: 'description' }, { id: 3, text: 'prioritary_fails' }, { id: 4, text: 'all_fails' }, { id: 5, text: 'fails' }, { id: 6, text: 'value' }]
  }),

  computed: {
    sortedReport: function () {
      this.$emit('icc', this.filteredReport.length)
      var order = this.type == 1 ? 1 : -1 // ascendant if sort type equals 1
      if ([2, 5, 6].includes(this.sort)) // sorts on colums (codes, fails, values)
      {
        var field = this.sorts.filter(x => x.id == this.sort, this)[0].text
        return this.filteredReport.sort(function (a, b) {
          if (a[field] < b[field]) { return -order }
          if (a[field] > b[field]) { return order }
          return 0
        })
      } else {
        if (this.sort == 1) // sort on codes
        {
          return this.filteredReport.sort(this.sortCodeCallback(order))
        } else if (this.sort == 3 || this.sort == 4) // prioritary Fails or details fails
        {
          // split in two lists (prioritary fail, no prio fail)
          // then sort by codes
          var field = this.sort == 3 ? 'prioritary' : 'details'
          var split = this.filteredReport.partition(function (a, b) { return a[field] })

          var sorted = []
          for (var i = 0; i < split.length; i++) {
            sorted.push(split[i].sort(this.sortCodeCallback(order)))
          }

          return [].concat.apply([], sorted)
        }
      }
    },

    filteredReport: function () {
      // see the Reports.vue component for the meaning of this switch case on filters ids
      switch (this.filter) {
        case 2: return this.report.filter(x => x.prioritary)
          break
        case 3: return this.report.filter(x => x.details)
          break
        case 4: return this.report.filter(x => x.prioritary || x.details)
          break
        case 5: return this.report.filter(x => x.fails == 0)
          break
        default:
          return this.report
      }
    }
  },

  mounted () {
    Array.prototype.partition = function (f) {
      var matched = [],
        unmatched = [],
        i = 0,
        j = this.length

      for (; i < j; i++) {
        (f.call(this, this[i], i) ? matched : unmatched).push(this[i])
      }

      return [matched, unmatched]
    }
  },

  methods: {
    sortCodeCallback (order) {
      var f = function (a, b) {
        var codesA = a.code.split('.').map(x => parseInt(x))
        var codesB = b.code.split('.').map(x => parseInt(x))
        var lenA = codesA.length
        var lenB = codesB.length
        var minLen = lenA < lenB ? lenA : lenB
        for (var i = 0; i < minLen; i++) {
          if (codesA[i] < codesB[i]) { return -order }
          if (codesA[i] > codesB[i]) { return order }
        }
        return order * (lenA - lenB)
      }
      return f
    },

    makeToolTip (el) {
      return el.fails_list.sort(this.sortCodeCallback(1)).map(x => `${x.code} ${x.description}`).join('\n')
    }
  }

}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ReportDisplay.vue